import React, { useState, useEffect, useCallback } from "react";
import "./SearchResultMobile.css";
import Truncate from "react-truncate";
import defaultProfil from "../../assets/profil/utilisateur.png";
import { checkIfFriend } from "../../services/stores/actions/compte";
import { statusGenerator } from "../../services/stores/actions/services";
import { attributesAll } from "../../res/constants";
import { GoArrowUpLeft } from "react-icons/go";
import ImageComponent from "../Image/image";

export const SearchResultWebCard = ({ title, img, videos, type }) => {
  return (
    <div className="SearchResultMobileCard col-xs-6 py-1 mx-1 k-semibold-13">
      <div className="img-container">
        <div className="positioning">
          <div className="row">
            <div className="col">
              <span className="diese">#</span>
              <div className="item-description ml-2">
                <p className="my-0 p-0 SearchResultMobileCardTitle k-semibold-13">
                  {title}
                </p>
                <span className="text-muted">
                  <p className="my-0 p-0 SearchResultMobileCardViewsCount">
                    {videos}
                  </p>
                </span>
              </div>
            </div>
          </div>
        </div>
        {type === "IMAGE" && (
          <img
            src={img}
            width={`160px`}
            height={`125px`}
            alt="result"
            className={`rounded`}
          />
        )}
        {type === "VIDEO" && (
          <video
            src={img}
            width={`160px`}
            height={`125px`}
            className={`rounded`}
            controlsList="nodownload"
            onContextMenu={(e) => e.preventDefault()}
          />
        )}
      </div>
    </div>
  );
};

export const SearchResultWebPourToi = ({
  img = "yona2",
  title = "User",
  description = "Name",
  bg_color = "yellow",
  userId = "0",
}) => {
  const [status, setStatus] = useState([]);

  const checkFriendShip = useCallback(
    function () {
      checkIfFriend(userId).then((response) => {
        const userStatus = statusGenerator({
          requestDetails: response,
          userId,
        });
        setStatus(userStatus);
      });
    },
    [userId]
  );

  useEffect(() => {
    checkFriendShip();
  }, [checkFriendShip, title, img]);

  return (
    <div
      className={`searchPagePourToi row mx-2 px-1 py-2 d-flex justify-content-between align-items-center`}
    >
      <div
        className="searchPagePourToiDescription ml-2 d-flex align-items-start"
        style={{ gap: "5px" }}
      >
        <ImageComponent
          widthParent={"35px"}
          heightParent={"35px"}
          isRounded={true}
          src={img ? img : defaultProfil}
          alt="profile"
        />
        <div className="d-flex align-items-start" style={{ gap: "5px" }}>
          <p className="k-semibold-13">{title}</p>
          {status?.includes(attributesAll.following) && (
            <p className="text-muted k-regular-11">✔ Followers</p>
          )}
        </div>
      </div>
      {/* <i className="fa fa-angle-right ml-1"></i> */}
      <GoArrowUpLeft size={20} />
    </div>
  );
};
// MObile
export const SearchResultMobileCard = ({ title, img, videos }) => {
  return (
    <div className="SearchResultMobileCard py-1 mx-1 k-semibold-13">
      <div className="img-container">
        <div className="positioning">
          <div className="row">
            <div className="col">
              <span className="diese">#</span>
              <div className="item-description ml-2">
                <p className="my-0 p-0 SearchResultMobileCardTitle k-semibold-13">
                  {title}
                </p>
                <span className="text-muted">
                  <p className="my-0 p-0 SearchResultMobileCardViewsCount">
                    {videos}
                  </p>
                </span>
              </div>
            </div>
          </div>
        </div>
        <img
          src={img}
          width={`160px`}
          height={`125px`}
          className={`rounded`}
          alt="profile"
        />
      </div>
    </div>
  );
};

export const SearchResultMobilePourToi = ({
  img = "MyBeeDoo",
  title = "",
  description = "Description",
  bg_color = "yellow",
  userId = "",
}) => {
  const [status, setStatus] = useState([]);

  const checkFriendShip = useCallback(
    function () {
      checkIfFriend(userId).then((response) => {
        const userStatus = statusGenerator({
          requestDetails: response,
          userId,
        });
        setStatus(userStatus);
      });
    },
    [userId]
  );

  useEffect(() => {
    checkFriendShip();
  }, [checkFriendShip, title, img]);

  return (
    <div
      className={`searchPagePourToi px-1 py-2 my-1 d-flex justify-content-between align-items-center`}
    >
      <div className="d-flex align-items-start" style={{ gap: "5px" }}>
        <img src={img} className="rounded_40" alt="profile" />
        <div
          className="searchPagePourToiDescription ml-2 d-flex"
          style={{ gap: "5px" }}
        >
          <p className="my-0 k-semibold-13">{title}</p>
          {status?.includes(attributesAll.following) && (
            <p className="text-muted k-regular-11">✔ Followers</p>
          )}
        </div>
      </div>
      <GoArrowUpLeft size={20} />
    </div>
  );
};
